import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'components';
import ColumnFilter from './ColumnFilter';
import ColumnSort from './ColumnSort';
import {
  StyledHeaderCell,
  FilterRow,
  LabelSortRow,
  Label,
  SortWrapper,
} from './TableHeaderCell.styled';

const TableHeaderCell = ({
  filter,
  filterType,
  filterValue,
  filterValueFrom,
  filterValueTo,
  filterValueYear,
  filterOptions,
  onFilter,
  onFilterFrom,
  onFilterTo,
  onFilterYear,
  filterPlaceholder,
  label,
  sort,
  sortDirection,
  onSort,
  labelAlign,
  isAction,
}) => (
  <StyledHeaderCell isAction={isAction}>
    <FilterRow>
      <Col size={{ xs: 1 }}>
        {filter ? (
          <ColumnFilter
            className="header-filter"
            type={filterType}
            value={filterValue}
            valueFrom={filterValueFrom}
            valueTo={filterValueTo}
            valueYear={filterValueYear}
            onChange={onFilter}
            onChangeFrom={onFilterFrom}
            onChangeTo={onFilterTo}
            onChangeYear={onFilterYear}
            options={filterOptions}
            placeholder={filterPlaceholder}
            small
            appliedValue={filterValue}
          />
        ) : (
          <div style={{ minHeight: 28 }} />
        )}
      </Col>
    </FilterRow>
    <LabelSortRow>
      <Label
        isAction={isAction}
        labelAlign={labelAlign === 'center' ? 'center' : labelAlign === 'right' ? 'flex-end' : 'flex-start'}
      >
        {label}
      </Label>
      <SortWrapper isAction={isAction}>
        {sort ? <ColumnSort direction={sortDirection} onSort={onSort} /> : null}
      </SortWrapper>
    </LabelSortRow>
  </StyledHeaderCell>
);

TableHeaderCell.propTypes = {
  filter: PropTypes.bool,
  filterType: PropTypes.oneOf(['input', 'select', 'datepicker', 'datepicker-range']),
  filterValue: PropTypes.any,
  filterValueFrom: PropTypes.any,
  filterValueTo: PropTypes.any,
  filterValueYear: PropTypes.any,
  filterOptions: PropTypes.array,
  onFilter: PropTypes.func,
  onFilterFrom: PropTypes.func,
  onFilterTo: PropTypes.func,
  onFilterYear: PropTypes.func,
  filterPlaceholder: PropTypes.string,
  label: PropTypes.node.isRequired,
  sort: PropTypes.bool,
  sortDirection: PropTypes.oneOf(['asc', 'desc', null]),
  onSort: PropTypes.func,
  labelAlign: PropTypes.oneOf(['left', 'center', 'right']),
  isAction: PropTypes.bool,
};

TableHeaderCell.defaultProps = {
  filter: false,
  filterType: 'input',
  filterValue: '',
  filterValueFrom: '',
  filterValueTo: '',
  filterValueYear: '',
  filterOptions: [],
  onFilter: () => {},
  onFilterFrom: () => {},
  onFilterTo: () => {},
  onFilterYear: () => {},
  filterPlaceholder: '',
  sort: false,
  sortDirection: null,
  onSort: () => {},
  labelAlign: 'left',
  isAction: false,
};

export default TableHeaderCell; 